(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-campaigns"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ws-campaigns')) {
    customElements.define('ws-campaigns', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ws-camp__track');
        this.real = [...this.track.querySelectorAll('.ws-camp__slide:not([data-clone])')];
        this.dots = [...this.querySelectorAll('.ws-camp__dot')];
        if (this.real.length < 2 || this.ac) return;
        this.ac = new AbortController();
        const sig = { signal: this.ac.signal };
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // one clone at each end so a half banner always shows on both sides, and the loop wraps seamlessly
        const makeClone = (src, side) => {
          const c = src.cloneNode(true);
          c.dataset.clone = side; c.removeAttribute('id'); c.removeAttribute('data-shopify-editor-block');
          c.setAttribute('aria-hidden', 'true'); c.querySelectorAll('a, button').forEach((a) => a.setAttribute('tabindex', '-1'));
          c.querySelectorAll('img').forEach((i) => i.setAttribute('loading', 'eager'));
          return c;
        };
        this.track.prepend(makeClone(this.real[this.real.length - 1], 'before'));
        this.track.append(makeClone(this.real[0], 'after'));
        this.all = [...this.track.querySelectorAll('.ws-camp__slide')];

        this.index = 0;
        this.center(this.real[0], 'instant');
        this.mark(0);

        this.querySelectorAll('.ws-camp__arrow').forEach((b) => b.addEventListener('click', () => this.go(this.index + Number(b.dataset.dir)), sig));
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(Number(d.dataset.i)), sig));
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
        }, sig);
        // clicking a side banner brings it to the centre instead of following its link
        this.track.addEventListener('click', (e) => {
          const s = e.target.closest('.ws-camp__slide');
          if (!s || s.classList.contains('is-active')) return;
          e.preventDefault();
          if (s.dataset.clone === 'before') this.go(this.index - 1);
          else if (s.dataset.clone === 'after') this.go(this.index + 1);
          else this.go(Number(s.dataset.i));
        }, sig);

        // mouse drag (touch already swipes natively): the track follows the pointer; on release, a drag past
        // 40px moves one slide that way via go(), so it wraps and animates exactly like the arrows
        let drag = null;
        this.track.addEventListener('dragstart', (e) => e.preventDefault(), sig);
        this.track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          drag = { x: e.clientX, left: this.track.scrollLeft, from: this.index, moved: false, id: e.pointerId };
        }, sig);
        this.track.addEventListener('pointermove', (e) => {
          if (!drag || e.pointerId !== drag.id) return;
          const dx = e.clientX - drag.x;
          if (!drag.moved) {
            if (Math.abs(dx) < 5) return;
            drag.moved = true;
            this.track.classList.add('is-dragging');
            this.track.setPointerCapture(e.pointerId);
          }
          this.track.scrollLeft = drag.left - dx;
        }, sig);
        const endDrag = (e) => {
          if (!drag || e.pointerId !== drag.id) return;
          const d = drag; drag = null;
          if (!d.moved) return;
          // keep snapping off until the slide has glided into place: turning it back on now makes the
          // browser snap straight back to the slide the drag started on before go() animates
          this.track.classList.remove('is-dragging');
          this.track.classList.add('is-settling');
          const dx = e.clientX - d.x;
          this.index = d.from;
          this.go(Math.abs(dx) > 40 ? d.from - Math.sign(dx) : d.from);
          this.dragEnd = performance.now();
        };
        this.track.addEventListener('pointerup', endDrag, sig);
        this.track.addEventListener('pointercancel', endDrag, sig);
        // the click that follows a drag must not open the banner's link
        this.track.addEventListener('click', (e) => {
          if (performance.now() - (this.dragEnd || 0) < 300) { e.preventDefault(); e.stopImmediatePropagation(); }
        }, { capture: true, signal: this.ac.signal });
        this.dragging = () => !!(drag && drag.moved);

        const settle = () => this.settle();
        if ('onscrollend' in window) this.track.addEventListener('scrollend', settle, sig);
        else this.track.addEventListener('scroll', () => { clearTimeout(this.st); this.st = setTimeout(settle, 140); }, sig);
        this.ro = new ResizeObserver(() => this.center(this.real[this.index], 'instant'));
        this.ro.observe(this.track);

        if (this.dataset.autoplay === 'true' && !this.reduce) {
          this.paused = false;
          ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => (this.paused = true), { passive: true, signal: this.ac.signal }));
          ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => (this.paused = false), sig));
          this.timer = setInterval(() => { if (!this.paused && !document.hidden && !this.dragging()) this.go(this.index + 1); }, Number(this.dataset.speed) || 6000);
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer); clearTimeout(this.st);
        this.ro && this.ro.disconnect(); this.ac && this.ac.abort(); this.ac = null;
        this.track && this.track.querySelectorAll('[data-clone]').forEach((c) => c.remove());
      }

      center(el, behavior) {
        const t = this.track.getBoundingClientRect(), r = el.getBoundingClientRect();
        const left = this.track.scrollLeft + (r.left - t.left) - (t.width - r.width) / 2;
        this.track.scrollTo({ left, behavior: behavior || (this.reduce ? 'instant' : 'smooth') });
      }

      go(i) {
        const n = this.real.length;
        // past either end: animate onto the clone, then settle() swaps to the real slide
        let target;
        if (i >= n) { target = this.all[this.all.length - 1]; i = 0; }
        else if (i < 0) { target = this.all[0]; i = n - 1; }
        else target = this.real[i];
        this.mark(i);
        this.center(target);
      }

      settle() {
        if (this.dragging && this.dragging()) return;
        this.track.classList.remove('is-settling');
        const t = this.track.getBoundingClientRect(), mid = t.left + t.width / 2;
        let best = null, dist = Infinity;
        for (const s of this.all) {
          const r = s.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid);
          if (d < dist) { dist = d; best = s; }
        }
        if (!best) return;
        if (best.dataset.clone) {
          const i = best.dataset.clone === 'after' ? 0 : this.real.length - 1;
          this.center(this.real[i], 'instant');
          this.mark(i);
        } else if (Number(best.dataset.i) !== this.index) {
          this.mark(Number(best.dataset.i));
        }
      }

      mark(i) {
        this.index = i;
        const n = this.real.length;
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
        this.all.forEach((s) => {
          const isClone = !!s.dataset.clone;
          // the clones mirror the wrap-around neighbours so they light up while animating onto them
          const real = isClone ? (s.dataset.clone === 'after' ? 0 : n - 1) : Number(s.dataset.i);
          const active = !isClone && real === i;
          s.classList.toggle('is-active', active);
          if (!isClone) {
            s.setAttribute('aria-hidden', active ? 'false' : 'true');
            s.querySelectorAll('a').forEach((a) => (active ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
